<template>
  <a-dropdown style="height: 100%; vertical-align: initial" >
    <span class="avatarClass" style="cursor: pointer">
        <el-avatar style="margin-right: 10px" :size="25" fit="fill" src="/static/img/avator.png"></el-avatar>
        <span>{{loginName}}</span>
    </span>
    <a-menu style="width: 150px;float:right;margin-right: -10%;" slot="overlay">
<!--      <a-menu-item>-->
<!--        <span  @click="myselfInfo">-->
<!--          <a-icon type="user" />-->
<!--          <span>个人中心</span>-->
<!--        </span>-->
<!--      </a-menu-item>-->
      <!--<a-menu-item>-->
        <!--<a-icon type="setting" />-->
        <!--<span>设置</span>-->
      <!--</a-menu-item>-->
      <!--<a-menu-divider />-->
      <a-menu-item  @click="logOut">
        <span>
          <a-icon type="poweroff" />
          <span>退出登录</span>
        </span>
      </a-menu-item>
    </a-menu>
  </a-dropdown>
</template>

<script>
import { mapGetters } from 'vuex'
import { queryDeptByUserId } from '../api/deptManager'
export default {
  name: 'HeaderAvatar',
  computed: {
    ...mapGetters([
      'userInfo',
      'loginName'
    ])
  },
  methods: {
    logOut () {
      // 清除缓存数据
      sessionStorage.removeItem('passwordToken')
      sessionStorage.removeItem('loginName')
      sessionStorage.removeItem('sessionId')
      localStorage.removeItem('clickSystemMenu')
      sessionStorage.removeItem('historyPath')
      this.$store.dispatch('LogOut').then(() => {
        // 为了重新实例化vue-router对象 避免bug
        // location.reload()
        this.$router.replace({ path: '/login' })
      })
    },
    myselfInfo () {
      let userId = this.userInfo.id
      queryDeptByUserId().then((res) => {
        let deptTree = res.data.data
        this.$router.push({path: '/system/editUser/', query: {userId: userId, deptId: deptTree[0].key, uCurrent: 1, pCurrent: 1, upageSize: 10, ppageSize: 10}})
      })
    }
  }
}
</script>

<style lang="less" scoped>
  .avatar{
    margin: 20px 4px 20px 0;
    color: #1890ff;
    background: hsla(0,0%,100%,.85);
    vertical-align: middle;
  }
  .avatarClass {
    display: flex;
    align-items: center;
    overflow: hidden;
    /*width: 200px;*/
    text-overflow:ellipsis;
    white-space: nowrap;
  }
</style>



// WEBPACK FOOTER //
// src/layouts/HeaderlAvatar.vue